import React from 'react';
import { Search, Tag } from 'lucide-react';

const CATEGORIES = [
  { id: 'all', name: 'All Posts' },
  { id: 'Technical', name: 'Technical' },
  { id: 'Business', name: 'Business' },
  { id: 'Industry', name: 'Industry Insights' },
];

const BlogFilters = ({ searchTerm, onSearchChange, selectedCategory, onCategoryChange }) => (
  <section className="py-12 bg-slate-800/50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
        {/* Category Filters */}
        <div className="flex flex-wrap gap-3">
          {CATEGORIES.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 flex items-center space-x-2 ${
                selectedCategory === category.id
                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-slate-900'
                  : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
              }`}
            >
              <Tag size={16} />
              <span>{category.name}</span>
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
          <input
            type="text"
            placeholder="Search articles..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10 pr-4 py-3 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-amber-500 focus:outline-none w-64"
          />
        </div>
      </div>
    </div>
  </section>
);

export default BlogFilters;
